const MESSAGES = {
  network:
    'We could not reach the server. Please check your connection and try again.',
  rateLimit:
    'The AI assistant is busy right now. Please wait a minute and try again.',
  timeout: 'That took too long. Please try again.',
  upload:
    'We could not upload your file. Please use an image, CSV, or Excel file and try again.',
  auth: 'Your session has expired. Please log in and try again.',
  chat: 'Something went wrong and I could not reply. Please try again in a moment.',
};

const TECHNICAL_PATTERNS = [
  { test: /429|rate limit|too many requests|status code 429/i, key: 'rateLimit' },
  {
    test: /failed to fetch|networkerror|load failed|econnrefused|enotfound|network request failed/i,
    key: 'network',
  },
  { test: /timeout|timed out|etimedout/i, key: 'timeout' },
  { test: /unsupported file type|no files uploaded|file upload failed/i, key: 'upload' },
  { test: /unauthorized|unauthenticated|session has expired/i, key: 'auth' },
];

const looksTechnical = (message) =>
  /status code \d{3}|axios|graphql|mongodb|econn|enotfound|internal server|undefined|null pointer/i.test(
    message
  );

const extractMessage = (error) => {
  if (!error) return '';
  if (typeof error === 'string') return error.trim();
  if (error instanceof Error) return error.message.trim();
  if (typeof error?.error === 'string') return error.error.trim();
  if (typeof error?.message === 'string') return error.message.trim();
  return String(error).trim();
};

export const getAgentErrorMessage = (error, { context = 'chat' } = {}) => {
  const raw = extractMessage(error);

  const match = TECHNICAL_PATTERNS.find(({ test }) => test.test(raw));
  if (match) return MESSAGES[match.key];

  if (!raw || looksTechnical(raw)) {
    return MESSAGES[context] || MESSAGES.chat;
  }

  return raw;
};
